document.addEventListener("DOMContentLoaded", function () {
    const videoSection = document.getElementById('videoSection');
    const video = document.getElementById('myVideo');
    const videoResponsive = document.getElementById('myVideoResponsive');
    const iconVolume = document.getElementById('iconVolume');
    const iconVolumeResponsive = document.getElementById('iconVolumeResponsive');
    const iconVolumeOn = document.getElementById('iconVolumeOn');
    const iconVolumeOnResponsive = document.getElementById('iconVolumeOnResponsive');
    const iconVolumeOff = document.getElementById('iconVolumeOff');
    const iconVolumeOffResponsive = document.getElementById('iconVolumeOffResponsive');

    let isPlaying = true;

    videoSection.addEventListener('click', function(event) {
      isPlaying == true ? video.pause() : video.play();
      isPlaying == true ? videoResponsive.pause() : videoResponsive.play();
      
      // Alternate isPlaying value after each click.
      isPlaying = !isPlaying;
    });

    let isMuted = true;
    let isMutedResponsive = true;

    iconVolume?.addEventListener('click', function(event) {
      if (isMuted) {
        video.muted = false;
        video.removeAttribute('muted', false);
        iconVolumeOn.classList.remove('hidden');
        iconVolumeOff.classList.add('hidden');
      } else {
        video.setAttribute('muted', true);
        video.muted = true;
        iconVolumeOn.classList.add('hidden');
        iconVolumeOff.classList.remove('hidden');
      }
      // Alternate isMuted value after each click on icon volume.
      isMuted = !isMuted;
    });

    iconVolumeResponsive?.addEventListener('click', function(event) {
      if (isMutedResponsive) {
        videoResponsive.muted = false;
        videoResponsive.removeAttribute('muted', false);
        iconVolumeOnResponsive.classList.remove('hidden');
        iconVolumeOffResponsive.classList.add('hidden');
      } else {
        videoResponsive.setAttribute('muted', true);
        videoResponsive.muted = true;
        iconVolumeOnResponsive.classList.add('hidden');
        iconVolumeOffResponsive.classList.remove('hidden');
      }
      // Alternate isMutedResponsive value after each click on icon volume.
      isMutedResponsive = !isMutedResponsive;
    });
});